import { defaultEstado, EstadoProps } from "./EstadoInterface";
import { defaultMunicipio, MunicipioProps } from "./MunicipioInterface";

//Definición de defaults

export const defaultCiudad: CiudadProps = {
    idCiudad:       0,
    clave:          '',
    descripcion:    '',
    activo:         false,
    idEstado:       0,
    estado:         defaultEstado,
    idMunicipio:    0,
    municipio:      defaultMunicipio,
}

// Creación de interfaces

export interface CiudadProps{
    idCiudad:       number;
    clave:          string;
    descripcion:    string;
    activo:         boolean;
    idEstado:       number;
    estado?:        EstadoProps;
    idMunicipio:    number;
    municipio?:     MunicipioProps;
}

export interface ObtenerCiudadesParams{
    idEstado:       number;
    idMunicipio:    number;
}